<template>
    <main id="form-alamat-wrapper">
        <div id="form-alamat-page">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'HCID', url:  app_url+'/hcid', status: false },
                    { title: 'Tukar Poin', url: app_url+ '/tukar-poin', status: true }
                ]"
            ></breadcrumb>
            <div class="container py-4">
                <div class="row justify-content-center">
                    <div class="container py-4">
                        <div class="row justify-content-center">
                            <div v-if="submitLoader" class="loading loading-double"></div>
                            <div class="col-md-12" v-else>
                                <div class="card">
                                    <div class="card-body">
                                        <h3 class="title">Alamat Pengiriman</h3>
                                            <form
                                            method="POST"
                                            @submit.prevent="onSubmit"
                                            @keydown="form.errors.clear($event.target.name)"
                                            enctype="multipart/form-data"
                                           >
                                            <div class="form-group row mt-4">
                                                <div class="col">
                                                    <div class="form-check form-check-isSame">
                                                        <input type="checkbox" class="form-check-input" id="isSame" @click="sameasprofile">
                                                        <label class="form-check-label" for="isSame">Sama dengan alamat profil</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="nama">Nama</label>
                                                <input
                                                    type="text"
                                                    class="form-control form-register"
                                                    id="nama"
                                                    aria-describedby="nama"
                                                    v-model="form.name"
                                                    placeholder="Masukkan Nama"
                                                />
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('name')"
                                                    v-text="form.errors.get('name')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="hp">Handphone</label>
                                                <input
                                                    type="number"
                                                    class="form-control form-register"
                                                    id="hp"
                                                    aria-describedby="hp"
                                                    placeholder="Masukkan No Telepon"
                                                    v-model="form.phone"
                                                />
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('phone')"
                                                    v-text="form.errors.get('phone')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="prov">Provinsi</label>
                                                    <div class="custom_vselect custom_vselect-large">
                                                        <v-select
                                                            :options="provinces"
                                                            label="name"
                                                            :placeholder="provincePlaceholder"
                                                            @input="changeProvince($event,'prov')"
                                                            v-model="prov"
                                                        >
                                                        </v-select>
                                                    </div>
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('prov')"
                                                    v-text="form.errors.get('prov')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="city">Kota</label>
                                                    <div class="custom_vselect custom_vselect-large">
                                                    <v-select
                                                        :options="cities"
                                                        label="name"
                                                        :placeholder="cityPlaceholder"
                                                        @input="changeCity($event,'city')"
                                                        v-model="city"
                                                    >
                                                    </v-select>
                                                    </div>
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('city')"
                                                    v-text="form.errors.get('city')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="alamat">Alamat Domisili</label>
                                                <input
                                                    type="text"
                                                    class="form-control form-register"
                                                    id="alamat"
                                                    aria-describedby="alamat"
                                                    placeholder="Masukkan Alamat Domisili"
                                                    v-model="form.address"
                                                />
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('address')"
                                                    v-text="form.errors.get('address')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="form-group row">
                                                <div class="col">
                                                <label class="label-form" for="zipcode">Kode Pos</label>
                                                <input
                                                    type="zipcode"
                                                    class="form-control form-register"
                                                    id="zipcode"
                                                    aria-describedby="zipcode"
                                                    placeholder="Masukkan zipcode"
                                                    v-model="form.zipcode"
                                                />
                                                    <span
                                                    class="help-block"
                                                    v-if="form.errors.has('zipcode')"
                                                    v-text="form.errors.get('zipcode')"
                                                    >
                                                    </span>
                                                </div>
                                            </div>
                                            <br />
                                            <div class="row justify-content-center">
                                                <a
                                                  :href="app_url+'/tukar-poin'"
                                                  class="btn mx-2 btn-white"
                                                >
                                                  Kembali
                                                </a>
                                                <button
                                                  type="submit"
                                                  class="btn mx-2 btn-red"
                                                >
                                                  Selanjutnya
                                                </button>
                                            </div>
                                            <br />
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";

export default {
    components: {
        breadcrumb: BreadCrumb,
        "v-select": vSelect,
    },
    data() {
        return {
            base_url:'',
            app_url:'',
            api_url:'',
            mobile: false,
            page: 1,
            provinces:[],
            prov:'',
            provincePlaceholder:'Pilih Provinsi',
            cities:[],
            city:'',
            cityPlaceholder:'Pilih Kota',
            product:'',
            user:null,
            submitLoader:false,
            form: new Form({
                    _token:token,
                    name:'',
                    phone:'',
                    prov:'',
                    city:'',
                    address:'',
                    zipcode:'',
                    product_id:'',
                    province:'',
                    kota:'',
                    notes:'',
                }),
            };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        if(localStorage.getItem('user') != null){
            this.user = JSON.parse(localStorage.getItem('user'));
        }
        this.getProvince();
        this.getProduct();
    },
    methods: {
        onSubmit() {
            this.submitLoader = true;
            this.form.post(api_url+"/member/redeem")
                .then((response) => {
                    this.submitLoader = false;

                    const productObj = {
                        name: this.product.name,
                        id: this.product.id,
                        poin: this.product.poin,
                        category: this.product.category
                    }

                    localStorage.setItem('hcid-redeem', this.user.hcid);
                    localStorage.setItem('product-redeemed', JSON.stringify(productObj));

                    if(response.status){
                        localStorage.setItem('redeem-success', true);
                        this.$router.push({ path: '/community/success-redeem'});
                    }else{
                        localStorage.setItem('redeem-gagal', response.message);
                        this.$router.push({ path: '/community/gagal-redeem'});
                    }
                    console.log(response)
                })
                .catch((response) => {
                    this.submitLoader = false;
                    console.log("ERROR = ", response);
                });
        },
        sameasprofile(){
            this.form.name = this.user.name === undefined ? '' : this.user.name;
            this.form.phone = this.user.phone === undefined ? '' : `0${this.user.phone}`;
            this.form.address = this.user.address === undefined ? '' : this.user.address;
            this.form.prov = this.user.province.id === undefined ? '' : this.user.province.id;
            this.form.city = this.user.city.id === undefined ? '' : this.user.city.id;
            this.form.province = this.user.province.name === undefined ? '' : this.user.province.name;
            this.form.kota = this.user.city.name === undefined ? '' : this.user.city.name;
            this.form.zipcode = this.user.zipcode === undefined ? '' : this.user.zipcode;
            this.provincePlaceholder = this.user.province.name === undefined ? '' : this.user.province.name;
            this.cityPlaceholder = this.user.city.name === undefined ? '' : this.user.city.name;
        },
        nextAction(){
            console.log(this.form)
            this.toggleModal();
            if (this.page == 1) {
                this.page = 2;
            } else {
                this.$router.push({ name: "success-redeem" });
            }
        },
        toggleModal() {
          $("#modalNext").modal("toggle");
          $(".modal-backdrop").remove();
        },
        backAction() {
          if (this.page == 2) {
            this.page = 1;
          } else {
            this.$router.push({ name: "home" });
          }
        },
        getProvince() {
                this.loadderforms = true;
                axios.get(api_url+'/static/province')
                    .then(response => {
                        this.provinces = response.data.data.provincy;
                        this.loadderforms = false;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        changeProvince(event,label){
            this.form[label] = event._id;
            this.getCity(event._id);
        },
        getCity(province) {
                axios.get(api_url+'/static/city/'+province)
                    .then(response => {
                        this.cities = response.data.data.city;
                    }).catch(error => {
                        console.log(error);
                    });
        },
        getProduct() {
                axios.get(api_url+'/product-detail/'+this.$route.params.slug)
                    .then(response => {
                        this.product = response.data.data.product;
                        this.form.product_id = response.data.data.product.id;
                        console.log(this.form);
                    }).catch(error => {
                        console.log(error);
                    });
        },
        changeCity(event,label){
            this.form[label] = event._id;
        },
    }
};
</script>

<style scoped lang="scss">
#form-alamat-page{
    background: #000000;

    .title-row-info{
        background: #1e1e1e;
    }
    .breadcrumb-image{
        max-height: 25px;
        display: inline-flex;
    }
    .breadcrumb-image-mobile{
        display: none;
    }
    .card{
        background: #FFFFFF;
        border-radius: 10px;
    }
    .title{
        font-family: Manrope;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
    }
    .form-check-isSame{
        font-family: Manrope;
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 22px;
        color: #000000;
    }
    .label-form{
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 24px;
        color: #3f3f3f;
    }
    .label-content{
        font-family: Manrope;
        font-style: normal;
        font-weight: 300;
        font-size: 15px;
        line-height: 24px;
        color: #4F4F4F;
    }
    .form-alamat{
        border-radius: 10px;
        border: 1px solid #dbdbdb;
        box-sizing: border-box;
        height: 60px;
    }
    .btn {
        width: 161px;
        height: 50px;
    }
    .btn-white {
        border: 1px solid #dbdbdb;
        box-sizing: border-box;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 35px;
        text-align: center;
        color: #e61b33;
    }
    .btn-red {
        background: #e61b33;
        border-radius: 10px;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 24px;
        text-align: center;
        color: #ffffff;
    }
    .modal-content {
        background: #ffffff;
        border-radius: 10px;
    }
    .modal-header {
        border-bottom: unset;
    }
    .modal-title {
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
        color: #e61b33;
    }
    @media (max-width: 768px) {
        .breadcrumb-image{
            display: none;
        }
        .breadcrumb-image-mobile{
            display: inline-flex;
            max-height: 25px;
        }
        .btn {
          width: 120px;
        }
        .modal-body {
          padding-left: 1.5rem !important;
          padding-right: 1.5rem !important;
        }
        .title {
          font-size: 18px;
        }
        .label-form {
          font-weight: 300;
        }
        .form-alamat {
          height: 40px;
        }
        select {
          background-position-x: 95.5%;
        }
    }
}
</style>
